import React from "react";
import { useNavigate } from "react-router-dom";
import service_six from "../images/cost effective.webp";
import ChatButton from "../components/ChatButton";
import { APP_NAME } from "../Utils/constant";
import { handleApplyNow } from "../Utils/navigation";


const CostEffective = () => {
  const navigate = useNavigate();
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>Cost Effective</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              <div className="content_banner">
                <img src={service_six} alt="" />
              </div>
              <h1 className="page_title mt30 mb20">
                Cost Effective Loan Services
              </h1>
              <p>
                At {APP_NAME}, we pride ourselves on providing cost-effective
                loan services designed to meet your financial needs without
                breaking the bank. Our competitive interest rates and
                transparent fee structures ensure that you receive the best
                value for your money. By offering loans with lower overall
                costs, we help you achieve your financial goals more
                efficiently. Our streamlined application process minimizes
                unnecessary expenses, saving you both time and money.
              </p>
              <br />
              <p>
                Furthermore, our commitment to cost-effectiveness extends beyond
                just the initial loan terms. We offer flexible repayment plans
                that can be adjusted to fit your budget, reducing the risk of
                financial strain. Our expert advisors work closely with you to
                identify the most economical options, ensuring you can manage
                your loan repayments comfortably. At {APP_NAME}, we believe
                that financial support should be accessible and affordable, and
                we strive to provide loan services that deliver exceptional
                value and long-term savings.
              </p>
              <br />
              <div className="button_container flex justify-center">
                <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default CostEffective;
